import React from 'react';
import PropTypes from 'prop-types';
import './MenuButton.css';

export const MenuButton = (
    {
        collapseSidebar,
    },
) => {
    return (
        <button className="btn waves-effect waves-float ps-topbar-menu-button" onClick={collapseSidebar}>
            <i className="material-icons">menu</i>
        </button>
    );
};

MenuButton.propTypes = {
    collapseSidebar: PropTypes.func.isRequired,
};

MenuButton.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/shared/components/layout/topbar/menu-button/MenuButton.jsx